import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeExitClearanceDto } from 'src/app/models/EmployeeExitClearanceDto';
import { ExitClearanceApprovalDto } from 'src/app/models/ExitClearanceApprovalDto';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { approveMovementVm } from 'src/app/models/approveMovementVm';
import { NotificationType } from 'src/app/models/notification.message';
import { Profile } from 'src/app/models/profile';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-exit-employee-user-mgt',
  templateUrl: './exit-employee-user-mgt.component.html',
  styleUrls: ['./exit-employee-user-mgt.component.css']
})
export class ExitEmployeeUserMgtComponent implements OnInit {
  ExitRequestApprovals: ExitClearanceApprovalDto[] = [];
  userList: Profile[] = [];
  selectedUser: Profile | null = null;
  selectedApproval: ExitClearanceApprovalDto | null = null;
  isChangeApproverModalVisible: boolean = false;
  
  constructor(private exitClearanceService: ExitClearanceService, private userService: UserService ) { }

  ngOnInit(): void {
this.openapproval();

  }
    async openapproval()
      {
  
        let resRequests = await this.exitClearanceService.GetExitClearanceApproval().toPromise();
        this.ExitRequestApprovals = <ExitClearanceApprovalDto[]>resRequests.responseData;
        this.formatApprovalDescriptions();
  
      }
      
      loadUsers() {
        this.userService.getUsers().subscribe({
          next: (response) => {
            this.userList = response.responseData || [];
          },
          error: (err) => {
            console.error('Error loading users:', err);
          }
        });
      }
      
      openChangeApproverModal(approval: ExitClearanceApprovalDto) {
        this.loadUsers();
        this.selectedApproval = approval;
        this.isChangeApproverModalVisible = true;
      }
    
      closeChangeApproverModal() {
        this.isChangeApproverModalVisible = false;
        this.selectedUser = null;
        this.selectedApproval = null;
      }
    
      confirmApproverChange(user: Profile | null) {
        
        
        if (this.selectedApproval && user) {
          // Update approver logic here
          const requestBody = {
            id:  this.selectedApproval.id, 
            userId: user.id
          }
          this.exitClearanceService.UpdateApprover(requestBody).subscribe(
            (response) => {
              if(response.responseData){
                if(this.selectedApproval)
                this.selectedApproval.approverEmail = user.email;
                this.closeChangeApproverModal();



              }
            }
          )
         
        }
      }
      
      formatApprovalDescriptions() {
        const descriptionCount: { [key: string]: number } = {};
      
        // Count occurrences of each description
        this.ExitRequestApprovals.forEach((approval) => {
          const desc = approval.checkListDescription;
          descriptionCount[desc] = (descriptionCount[desc] || 0) + 1;
        });
      
        // Append approver labels if there are duplicates
        const descriptionIndex: { [key: string]: number } = {};
        
        this.ExitRequestApprovals.forEach((approval) => {
          const desc = approval.checkListDescription;
          
          if (descriptionCount[desc] > 1) {
            descriptionIndex[desc] = (descriptionIndex[desc] || 0) + 1;
            approval.checkListDescription = `${desc} (Approver ${descriptionIndex[desc]})`;
          }
        });
      
      
      }
}
